import '../_virtual/howler.js';
import { AudioPlayer } from './audio-player.js';
import { AudioPlayerStatus } from './audio-player.enum.js';
import { isFunction } from '../node_modules/.pnpm/is-what@5.5.0/node_modules/is-what/dist/isFunction.js';

const AudioPlayerSingleton = Object.freeze(
  () => {
    let audioPlayer = void 0;
    const eventListeners = {
      errorchange: [],
      statuschange: [],
      load: [],
      play: [],
      end: [],
      pause: [],
      stop: [],
      mute: [],
      volume: [],
      rate: [],
      seek: [],
      fade: [],
      unlock: [],
      loaderror: [],
      playerror: []
    };
    return {
      get eventListenerList() {
        return audioPlayer?.eventListenerList;
      },
      get options() {
        return audioPlayer?.options;
      },
      get error() {
        return audioPlayer?.error;
      },
      get status() {
        return audioPlayer?.status;
      },
      get soundId() {
        return audioPlayer?.soundId;
      },
      play(options) {
        if (options) {
          if (audioPlayer) {
            const pOptions = audioPlayer.options;
            if (pOptions.src !== options.src || pOptions.volume !== options.volume || pOptions.loop !== options.loop || pOptions.rate !== options.rate) {
              audioPlayer.stop().unload();
              audioPlayer = new AudioPlayer(options);
              audioPlayer?.replaceEventListeners(eventListeners);
            }
          } else {
            audioPlayer = new AudioPlayer(options);
            audioPlayer?.replaceEventListeners(eventListeners);
          }
        }
        if (audioPlayer && audioPlayer.status !== AudioPlayerStatus.PLAYING) {
          audioPlayer?.play();
        }
        return this;
      },
      pause() {
        audioPlayer?.pause();
        return this;
      },
      stop() {
        audioPlayer?.stop();
        return this;
      },
      load() {
        audioPlayer?.load();
        return this;
      },
      unload() {
        audioPlayer?.unload();
        return this;
      },
      on(event, callback) {
        eventListeners[event].unshift(callback);
        audioPlayer?.replaceEventListeners(eventListeners);
        return this;
      },
      off(event, callback) {
        if (event) {
          if (!callback) {
            eventListeners[event].splice(0);
          } else if (isFunction(callback)) {
            const listeners = eventListeners[event];
            for (let i = listeners.length - 1; i >= 0; i--) {
              if (listeners[i] === callback) {
                listeners.splice(i, 1);
              }
            }
          }
        } else {
          Object.keys(eventListeners).forEach((key) => {
            eventListeners[key].splice(0);
          });
        }
        audioPlayer?.replaceEventListeners(eventListeners);
        return this;
      },
      once(event, callback) {
        const wrapper = (...args) => {
          callback.apply(this, args);
          this.off(event, wrapper);
        };
        eventListeners[event].unshift(wrapper);
        audioPlayer?.replaceEventListeners(eventListeners);
        return this;
      }
    };
  }
)();

export { AudioPlayerSingleton };
//# sourceMappingURL=audio-player-singleton.js.map
